import {SupportContactFormService} from "webform/gen/supportContactForm";
import * as HttpClientLibrary from "@bolteu/http-client-bolt-server";

import {ErrorType} from "config/errors";
import {getSessionState} from "utils/getSessionState";

import {getAppVersion} from "./utils/getAppVersion";
import {getToken} from "webform/api/utils/getToken";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const localeParam = urlParams.get("locale");
const sessionState = getSessionState();
const locale = localeParam || sessionState?.locale || navigator.language;

export function getDefaultQueryParams() {
    const version = getAppVersion("SF");
    return {
        device_name: "support_webform",
        device_os_version: navigator.userAgent,
        deviceId: "",
        deviceType: navigator.platform,
        language: locale,
        version,
    };
}

export const getSupportContactFormHttpClient = () => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;
    if (baseUrl === undefined) {
        console.error("[notify]", ErrorType.CONFIG_MISSING_API_URL, "Webform API: Missing base api url");
        throw new Error("Missing base api url");
    }
    return new HttpClientLibrary.HttpClientBoltServer<SupportContactFormService.HttpClientConstraints>({
        baseUrl,
    });
};

export const initSupportContactFormHttpClient = (
    httpClient: HttpClientLibrary.HttpClientBoltServer<SupportContactFormService.HttpClientConstraints>,
) => {
    const token = getToken();
    if (!token) {
        throw Error(ErrorType.NO_AUTH_TOKEN);
    }
    httpClient.init({
        standardRequestStrategy: {
            getStandardRequest: getDefaultQueryParams,
        },
        authStrategy: {
            jwt: {
                getAuthToken: () => token,
            },
        },
    });
};

export const createSupportWebformApi = () => {
    const httpClient = getSupportContactFormHttpClient();
    initSupportContactFormHttpClient(httpClient);
    return new SupportContactFormService.ApiClient({
        httpClient,
    });
};
